import React from 'react';
import {Helmet} from 'react-helmet-async';
import {Link} from 'react-router-dom';
import soltLogo from '../assets/logo.png';
import {APP_STORE_URL} from '../constants/app';
import {SEO_PUBLISHED_CITIES, geoBestRestaurantsPath, geoCityPath} from '../data/geoRoutes';
import './NotFound.css';

const NotFound: React.FC = () => {
    const bucharest = SEO_PUBLISHED_CITIES.find((g) => g.citySlug === 'bucharest');

    return (
        <div className="not-found-page">
            <Helmet>
                <title>Page not found | Solt</title>
                <meta name="robots" content="noindex, follow"/>
            </Helmet>
            <header className="not-found-header">
                <Link to="/">
                    <img src={soltLogo} alt="Solt" className="not-found-logo"/>
                </Link>
            </header>
            <main className="not-found-main">
                <h1>Page not found</h1>
                <p>This page does not exist or may have moved.</p>
                <div className="not-found-actions">
                    <Link to="/" className="not-found-primary">
                        Back to home
                    </Link>
                    {bucharest && (
                        <>
                            <Link to={geoCityPath(bucharest)} className="not-found-secondary">
                                Where to eat in Bucharest
                            </Link>
                            <Link to={geoBestRestaurantsPath(bucharest)} className="not-found-secondary">
                                Best restaurants in Bucharest
                            </Link>
                        </>
                    )}
                    <a
                        href={APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="not-found-secondary"
                    >
                        Get the app
                    </a>
                </div>
            </main>
        </div>
    );
};

export default NotFound;
